/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TransactionStatusSearch = 0 | 1 | 2;

export const TransactionStatusSearch = {

    NUMBER_0: 0 as TransactionStatusSearch,

    NUMBER_1: 1 as TransactionStatusSearch,

    NUMBER_2: 2 as TransactionStatusSearch
};

